module.exports = __webpack_public_path__ + "img/193.1befeca2.jpg";